import { IconLayer } from '@deck.gl/layers/typed';
import { svgToDataURL } from 'app/helpers';
import { getHoverIcon } from 'helpers/getWebGLPointIcon';
import { useAppSelector } from 'app/store/store';
import { PickingInfo } from '@deck.gl/core/typed';

export const useLayerTargetHovered = () => {
  const mode = useAppSelector((state) => state.mapStateSlice.mode);
  const isNotBaseMode = mode === 'analytics' || mode === 'playback';

  const hoveredTarget = useAppSelector((state) => state.mapStateSlice.hoveredTarget);

  const layerTargetHovered = new IconLayer({
    id: 'layer-target-hovered-frame',
    data: [hoveredTarget],
    pickable: true,
    visible: hoveredTarget?.object && !isNotBaseMode,
    getPosition: (d: PickingInfo): [number, number, number] => {
      if (typeof d?.object?.lon === 'number' && typeof d?.object?.lon === 'number') return [d.object.lon, d.object.lat, 0];
      return [999, 999, 0];
    },
    getIcon: () => ({
      url: svgToDataURL(getHoverIcon()),
      width: 28,
      height: 28,
    }),

    updateTriggers: {
      getIcon: hoveredTarget?.object ? hoveredTarget.object : null,
    },

    sizeMinPixels: 28,
  });
  return layerTargetHovered;
};
